import { defineMessages } from 'react-intl';

const MESSAGES = defineMessages({
    formsTitle: {
        defaultMessage: 'Forms',
        id: 'iaso.forms.title',
    },
    entitiesTitle: {
        defaultMessage: 'Entities',
        id: 'iaso.entities.title',
    },
    entityTypesTitle: {
        defaultMessage: 'Entity types',
        id: 'iaso.entityTypes.title',
    },
    submissionsTitle: {
        defaultMessage: 'Submissions',
        id: 'iaso.instance.title',
    },

    formsStats: {
        defaultMessage: 'Form Stats',
        id: 'iaso.forms.stats.title',
    },
    list: {
        defaultMessage: 'List',
        id: 'iaso.label.list',
    },
    formList: {
        defaultMessage: 'Form List',
        id: 'iaso.label.formList',
    },
    orgUnitList: {
        defaultMessage: 'Org unit List',
        id: 'iaso.label.orgUnitList',
    },
    dataSourceList: {
        defaultMessage: 'Data Sources List',
        id: 'iaso.label.dataSourceList',
    },
    linksList: {
        defaultMessage: 'Links List',
        id: 'iaso.label.linksList',
    },
    entitiesList: {
        defaultMessage: 'Entities List',
        id: 'iaso.label.entitiesList',
    },
    planningList: {
        defaultMessage: 'Planning List',
        id: 'iaso.label.planningList',
    },
    dhis2Mappings: {
        defaultMessage: 'DHIS mappings',
        id: 'iaso.label.dhis2Mappings',
    },
    completeness: {
        defaultMessage: 'Completeness',
        id: 'iaso.completeness.title',
    },
    completenessStats: {
        defaultMessage: 'Completeness Stats',
        id: 'iaso.completenessStats.title',
    },
    archived: {
        defaultMessage: 'Archived',
        id: 'iaso.archived.title',
    },
    orgUnitsTitle: {
        defaultMessage: 'Org units',
        id: 'iaso.orgUnits.title',
    },
    groups: {
        defaultMessage: 'Groups',
        id: 'iaso.label.groups',
    },
    groupSets: {
        defaultMessage: 'Group Sets',
        id: 'iaso.label.groupSets',
    },
    orgUnitType: {
        id: 'iaso.orgUnits.orgUnitsTypes',
        defaultMessage: 'Organisation unit type',
    },
    dataSources: {
        id: 'iaso.orgUnits.dataSources',
        defaultMessage: 'Data Sources',
    },
    matching: {
        defaultMessage: 'Matching',
        id: 'iaso.matching.title',
    },
    algorithmsRuns: {
        defaultMessage: 'Algorithms runs',
        id: 'iaso.label.algorithmsRuns',
    },
    config: {
        defaultMessage: 'Admin',
        id: 'iaso.label.config',
    },
    users: {
        defaultMessage: 'Users',
        id: 'iaso.label.users',
    },
    userRoles: {
        defaultMessage: 'User Roles',
        id: 'iaso.label.userRoles',
    },
    projects: {
        defaultMessage: 'Projects',
        id: 'iaso.label.projects',
    },
    tasks: {
        defaultMessage: 'Tasks',
        id: 'iaso.label.tasks',
    },
    monitoring: {
        defaultMessage: 'Monitoring',
        id: 'iaso.label.monitoring',
    },
    dashboard: {
        defaultMessage: 'Dashboard',
        id: 'iaso.label.dashboard',
    },
    polio: {
        defaultMessage: 'Polio',
        id: 'iaso.label.polio',
    },
    pages: {
        defaultMessage: 'Embedded links',
        id: 'iaso.label.pages',
    },
    planning: {
        defaultMessage: 'Planning',
        id: 'iaso.label.planning',
    },
    teams: {
        defaultMessage: 'Teams',
        id: 'iaso.label.teams',
    },
    assignments: {
        defaultMessage: 'Assignments',
        id: 'iaso.label.assignments',
    },
    dhis2: {
        defaultMessage: 'Go to DHIS2',
        id: 'iaso.label.dhis2Link',
    },
    legend: {
        defaultMessage: 'Legend',
        id: 'iaso.label.map.legend',
    },
    unselected: {
        defaultMessage: 'Not assigned',
        id: 'iaso.assignment.map.unselected',
    },
    disabled: {
        defaultMessage: 'Already assigned',
        id: 'iaso.assignment.map.disabled',
    },
    parent: {
        defaultMessage: 'Parent',
        id: 'iaso.assignment.map.parent',
    },
    entities: {
        defaultMessage: 'Entities',
        id: 'iaso.label.entities',
    },
    stockManagement: {
        defaultMessage: 'Stock Management',
        id: 'iaso.label.stockManagement',
    },
    storages: {
        defaultMessage: 'External storage',
        id: 'iaso.label.storages',
    },
    storages_tooltip: {
        defaultMessage: 'NFC cards data management',
        id: 'iaso.label.tooltip.storages',
    },
    registry: {
        defaultMessage: 'Registry',
        id: 'iaso.registry.title',
    },
    entityDuplicatesTitle: {
        defaultMessage: 'Duplicates',
        id: 'iaso.label.duplicates',
    },
    entityDuplicateAnalysesTitle: {
        defaultMessage: 'Duplicate Analyses',
        id: 'iaso.label.duplicateAnalyses',
    },
    modules: {
        defaultMessage: 'Modules',
        id: 'iaso.label.modules',
    },
    reviewChangeProposals: {
        defaultMessage: 'Review change proposals',
        id: 'iaso.label.reviewChangeProposals',
    },
    payments: {
        defaultMessage: 'Payments',
        id: 'iaso.payments.title',
    },
    potentialPayments: {
        defaultMessage: 'Potential payments',
        id: 'iaso.payments.potentialPayments',
    },
    lots: {
        defaultMessage: 'Payments lots',
        id: 'iaso.payments.lots',
    },
    history: {
        defaultMessage: 'History',
        id: 'iaso.label.history',
    },
    management: {
        defaultMessage: 'Management',
        id: 'iaso.label.management',
    },
    configuration: {
        defaultMessage: 'Configuration',
        id: 'iaso.label.configuration',
    },
    changeRequestConfig: {
        defaultMessage: 'Change Request',
        id: 'iaso.label.changeRequestConfig',
    },
    stats: {
        defaultMessage: 'Stats',
        id: 'iaso.label.stats',
    },
    validation: {
        defaultMessage: 'Validation',
        id: 'iaso.label.validation',
    },
    accountSetup: {
        defaultMessage: 'Setup a new account',
        id: 'iaso.setup.accountSetup',
    },
    skus: {
        defaultMessage: 'Stock Keeping Units',
        id: 'iaso.label.stockkeepingunits',
    },
    stockItems: {
        defaultMessage: 'Stock entries',
        id: 'iaso.label.stockItems',
    },
});

export default MESSAGES;
